/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Heating_Network_Type_Convection_HeaterInputs */



/**
* | output |
* | --- |
* | "Convection heater" |
*
* @param {Heating_Network_Type_Convection_HeaterInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const heating_network_type_convection_heater = /** @type {((inputs?: Heating_Network_Type_Convection_HeaterInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Heating_Network_Type_Convection_HeaterInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Convection heater")
	return /** @type {LocalizedString} */ ("Convecteur")
});